import React, {forwardRef} from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";


const StyledProductListGrid = styled('div')`
    display: grid;
    grid-template-columns: repeat(2, calc((100% - ${() => `var(${GLOBAL_STYLE_CONFIG.variable('product-list', 'column-gap')}, 10px)`}) / 2));
    column-gap: ${() => `var(${GLOBAL_STYLE_CONFIG.variable('product-list', 'column-gap')}, 10px)`};
    row-gap: ${() => `var(${GLOBAL_STYLE_CONFIG.variable('product-list', 'row-gap')}, 12px)`};

    @media (min-width: ${({theme}) => theme.breakpoints.sm}) {
        grid-template-columns: repeat(auto-fill, minmax(clamp(150px, 20vw, 180px), 1fr));
    }

    @media (min-width: ${({theme}) => theme.breakpoints.xl}) {
        column-gap: ${() => `var(${GLOBAL_STYLE_CONFIG.variable('product-list', 'column-gap-xl')}, 20px)`};
        row-gap: ${() => `var(${GLOBAL_STYLE_CONFIG.variable('product-list', 'column-row-xl')}, 24px)`};
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('card')} {
    }

`

interface Props {
    children: React.ReactNode;
}

/**
 * Компонент для отображения списка товаров в виде сетки.
 */
const ProductListGrid = forwardRef<HTMLDivElement, Props>(({children}, ref) => {
    return (
        <StyledProductListGrid ref={ref} className={GLOBAL_STYLE_CONFIG.splitByPrefix('product-content')}>
            {children}
        </StyledProductListGrid>
    );
});
export default ProductListGrid;